import { Link } from 'react-router-dom';
import Navbar from '../../home/components/Navbar';
import Footer from '../../home/components/Footer';
import PageHero from '../../../components/feature/PageHero';
import SEOHead from '../../../components/feature/SEOHead';
import CountdownTimer from '../../../components/feature/CountdownTimer';

export default function SuporteAcompanhamentoPage() {
  const serviceSchema = {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": "Suporte e Acompanhamento em Seguros",
    "provider": {
      "@type": "Organization",
      "name": "IBX Brasil"
    },
    "description": "Suporte contínuo e acompanhamento especializado em seguros empresariais com atendimento dedicado, gestão de sinistros e consultoria permanente.",
    "serviceType": "Suporte e Acompanhamento em Seguros",
    "areaServed": "BR"
  };

  return (
    <>
      <SEOHead
        title="Suporte e Acompanhamento em Seguros | Atendimento Dedicado"
        description="Suporte contínuo e acompanhamento especializado em seguros empresariais. Atendimento dedicado, gestão de sinistros, consultoria permanente e tranquilidade para sua empresa."
        canonical="https://ibxbrasil.com.br/servicos/suporte-acompanhamento"
        ogImage="https://readdy.ai/api/search-image?query=professional%20customer%20support%20specialist%20assisting%20client%20with%20insurance%20consultation%20modern%20office%20friendly%20atmosphere%20handshake%20professional%20service%20clean%20background%20realistic%20corporate%20photography&width=1200&height=630&seq=seo-suporte-acompanhamento-service&orientation=landscape"
        ogType="service"
        schema={serviceSchema}
      />
      <div className="min-h-screen bg-white">
        <Navbar />
        
        {/* Hero Section */}
        <PageHero
          badge="SERVIÇOS • SUPORTE E ACOMPANHAMENTO"
          title="Suporte Contínuo e Acompanhamento Estratégico"
          highlightedWord="Acompanhamento"
          highlightColor="green"
          subtitle="Monitoramento permanente de apólices, suporte técnico em sinistros e gestão proativa de renovações para garantir proteção contínua."
          benefits={[
            'Suporte técnico 24/7',
            'Monitoramento contínuo de apólices',
            'Gestão proativa de renovações',
            'Acompanhamento em sinistros'
          ]}
          ctaText="Falar no WhatsApp"
          ctaLink="https://wa.me/5577988080505?text=Olá! Gostaria de saber mais sobre suporte e acompanhamento."
          ctaSecondary={{
            text: 'Solicitar Análise',
            link: '#contato'
          }}
          backgroundImage="https://readdy.ai/api/search-image?query=professional%20insurance%20support%20team%20in%20modern%20customer%20service%20center%20with%20digital%20systems%20monitoring%20screens%20professional%20atmosphere%20business%20efficiency&width=1920&height=700&seq=suporte-acompanhamento-hero-001&orientation=landscape"
          overlayOpacity="medium"
        />

        {/* Support Types */}
        <section className="py-20">
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">
                Tipos de Suporte Oferecidos
              </h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                Atendimento completo para todas as suas necessidades
              </p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              <div className="bg-white border border-gray-200 rounded-lg p-8">
                <div className="w-14 h-14 bg-orange-100 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-question-answer-line text-2xl text-orange-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Dúvidas sobre Coberturas</h3>
                <p className="text-gray-600 leading-relaxed">
                  Esclarecimento de dúvidas sobre o que está ou não coberto pela apólice contratada.
                </p>
              </div>

              <div className="bg-white border border-gray-200 rounded-lg p-8">
                <div className="w-14 h-14 bg-orange-100 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-file-edit-line text-2xl text-orange-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Alterações Contratuais</h3>
                <p className="text-gray-600 leading-relaxed">
                  Suporte para inclusão ou exclusão de coberturas, alteração de dados e endossos.
                </p>
              </div>

              <div className="bg-white border border-gray-200 rounded-lg p-8">
                <div className="w-14 h-14 bg-orange-100 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-alert-line text-2xl text-orange-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Orientação em Sinistros</h3>
                <p className="text-gray-600 leading-relaxed">
                  Suporte imediato em caso de sinistro com orientação sobre procedimentos e documentação.
                </p>
              </div>

              <div className="bg-white border border-gray-200 rounded-lg p-8">
                <div className="w-14 h-14 bg-orange-100 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-calendar-check-line text-2xl text-orange-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Controle de Vigências</h3>
                <p className="text-gray-600 leading-relaxed">
                  Alertas de vencimento e preparação antecipada para renovações estratégicas.
                </p>
              </div>

              <div className="bg-white border border-gray-200 rounded-lg p-8">
                <div className="w-14 h-14 bg-orange-100 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-money-dollar-circle-line text-2xl text-orange-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Análise de Reajustes</h3>
                <p className="text-gray-600 leading-relaxed">
                  Avaliação técnica de reajustes aplicados e negociação quando necessário.
                </p>
              </div>

              <div className="bg-white border border-gray-200 rounded-lg p-8">
                <div className="w-14 h-14 bg-orange-100 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-file-list-3-line text-2xl text-orange-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Documentação e Registros</h3>
                <p className="text-gray-600 leading-relaxed">
                  Organização de apólices, endossos, comprovantes e histórico de comunicações.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Service Levels */}
        <section className="py-20">
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">
                Níveis de Atendimento
              </h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                Suporte estruturado conforme a urgência
              </p>
            </div>

            <div className="grid md:grid-cols-3 gap-8">
              <div className="bg-gradient-to-br from-red-50 to-white border-2 border-red-200 rounded-lg p-8">
                <div className="w-14 h-14 bg-red-100 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-alarm-warning-line text-2xl text-red-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Urgente</h3>
                <p className="text-gray-600 mb-4 leading-relaxed">
                  Sinistros e situações emergenciais
                </p>
                <div className="space-y-2">
                  <div className="flex items-center gap-2">
                    <i className="ri-time-line text-red-600"></i>
                    <span className="text-sm text-gray-600">Resposta imediata</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <i className="ri-whatsapp-line text-red-600"></i>
                    <span className="text-sm text-gray-600">Atendimento via WhatsApp</span>
                  </div>
                </div>
              </div>

              <div className="bg-gradient-to-br from-orange-50 to-white border-2 border-orange-200 rounded-lg p-8">
                <div className="w-14 h-14 bg-orange-100 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-speed-line text-2xl text-orange-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Prioritário</h3>
                <p className="text-gray-600 mb-4 leading-relaxed">
                  Alterações contratuais e dúvidas técnicas
                </p>
                <div className="space-y-2">
                  <div className="flex items-center gap-2">
                    <i className="ri-time-line text-orange-600"></i>
                    <span className="text-sm text-gray-600">Resposta em até 4 horas</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <i className="ri-mail-line text-orange-600"></i>
                    <span className="text-sm text-gray-600">WhatsApp ou e-mail</span>
                  </div>
                </div>
              </div>

              <div className="bg-gradient-to-br from-gray-50 to-white border-2 border-gray-200 rounded-lg p-8">
                <div className="w-14 h-14 bg-gray-100 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-calendar-line text-2xl text-gray-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Padrão</h3>
                <p className="text-gray-600 mb-4 leading-relaxed">
                  Consultas gerais e solicitações de rotina
                </p>
                <div className="space-y-2">
                  <div className="flex items-center gap-2">
                    <i className="ri-time-line text-gray-600"></i>
                    <span className="text-sm text-gray-600">Resposta em até 24 horas</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <i className="ri-mail-line text-gray-600"></i>
                    <span className="text-sm text-gray-600">E-mail ou telefone</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Final */}
        <section className="py-20 bg-gradient-to-br from-orange-600 to-orange-700">
          <div className="max-w-4xl mx-auto px-6 text-center">
            <CountdownTimer location="paginas-servicos" />
            <h2 className="text-4xl font-bold text-white mb-6">
              Tenha Suporte Especializado Sempre que Precisar
            </h2>
            <p className="text-xl text-orange-100 mb-8">
              Entre em contato e conte com nosso acompanhamento contínuo
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <a
                href="https://wa.me/5577988080505"
                target="_blank"
                rel="noopener noreferrer"
                className="px-8 py-4 bg-white text-orange-600 rounded-lg font-semibold hover:bg-orange-50 transition-colors duration-300 flex items-center gap-2 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line text-2xl"></i>
                <span>Falar no WhatsApp</span>
              </a>
              <a
                href="/contato"
                className="inline-flex items-center gap-2 px-8 py-4 bg-strategic-green-500 text-white font-semibold rounded-lg transition-all duration-300 hover:bg-strategic-green-600 hover:scale-105 hover:shadow-xl whitespace-nowrap"
              >
                Solicitar Suporte
                <i className="ri-arrow-right-line text-xl"></i>
              </a>
              <a
                href="/servicos"
                className="inline-flex items-center justify-center px-6 py-3 bg-action-orange-500 text-white font-semibold rounded-lg hover:bg-action-orange-600 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap"
              >
                Ver Outros Serviços
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
}